import React, { useMemo } from 'react'
import {
  Box,
  Text,
} from '@usap/uicomponents'

const checkStatus = props => {
  let {
    messaging, title, hasETA, shippingCompany, etaReadable,
  } = { ...props }
  const { dateToArrive, parts = {}, dateFormat } = { ...props }

  switch (title) {
    case 'Pending':
    case 'Processing':
    case 'Shipped':
    case 'Order Shipped':
    case 'In Transit':
      hasETA = true

      if (parts?.shipping?.date_created) title = 'In Transit'
      break
    case 'Cancelled':
      messaging = 'This order is either cancelled or out of stock. To discuss your order with our customer advocacy team, please call 1-866-529-0412.'
      break
    case 'Delivered':
      messaging = parts?.shipping?.shipping_company
        ? `via ${parts.shipping.shipping_company}`
        : ''
      break
    default:
      messaging = ''
  }

  if (hasETA && dateToArrive) {
    const parsedDate = new Date(dateToArrive)
    if(!isNaN(parsedDate)) {
      shippingCompany = parts?.shipping?.shipping_company
        ? ` via ${parts.shipping.shipping_company}`
        : ''
      messaging = 'Your order will arrive by: '
      etaReadable = dateFormat.format(parsedDate)
    }
  }

  return {
    messaging, title, hasETA, shippingCompany, etaReadable,
  }
}

const useEtaToshow = props => {
  const {
    parts, showTabs, hasEligibleStatus, hasRMA, OpenChatHandler,
  } = { ...props }

  return useMemo(() => {
    const dateFormat = new Intl.DateTimeFormat('en-US', {
      weekday: 'short',
      month: 'short',
      day: 'numeric',
      timeZone: 'UTC',
    })

    const {
      messaging, title, shippingCompany, etaReadable,
    } = checkStatus({
      messaging: '',
      title: parts.order_item_status || 'Pending',
      hasETA: false,
      dateToArrive: parts.ETA || null,
      dateFormat,
    })

    if (showTabs || hasEligibleStatus || hasRMA) return null

    return (
      <Box
        style={{
          background: '#fffad0',
          padding: '10px 15px',
          marginTop: '10px',
        }}
      >
        <Text
          style={{
            fontWeight: 'bold',
            fontSize: '1rem',
          }}
        >
          {title}
        </Text>
        {messaging && (
          title === 'Cancelled' ? (
            <Text size="xsmall" color="dark-2">
              {'This order is either cancelled or out of stock. If you have any questions or concerns, you can contact us through our '}
              <button
                onClick={event => {
                  event.preventDefault()
                  OpenChatHandler()
                }}
                href="#"
                rel="noreferrer"
                style={{
                  color: '#05629B',
                  cursor: 'pointer',
                  background: 'none',
                  border: 'none',
                  padding: 0,
                  fontSize: '12px',
                  fontWeight: 'bold',
                }}
              >
                {'Live Chat'}
              </button>
              {'. Our chat agents are available Mon-Sun from 4 AM to 8 PM PST.'}
            </Text>
          ) : (
            <Text
              style={{
                fontSize: '14px',
              }}
            >
                {messaging}
                {etaReadable && (
                  <Text style={{ fontWeight: 'bold', fontSize: '14px' }}>
                    {etaReadable}
                    &nbsp;
                    {shippingCompany}
                  </Text>
                )}
            </Text>
          )
        )}
      </Box>
    )
  }, [parts, showTabs, hasEligibleStatus, hasRMA])
}

export default useEtaToshow
